import socketIOClient from "socket.io-client";
import {  API_ENDPOINT_Socket } from "../../AppConfig";
import {
    FETCH_NEW_MESSAGE,
    UPDATE_NOTIFICATION_COUNT,
    UPDATE_MESSAGE_COUNT,
    DELETE_NEW_MESSAGE,
    FETCH_USER_TYPING,
    CLEAR_MSG_COUNT,
    CLEAR_NOTIFICATION_COUNT
} from "./type";
var guest;
let NotifSocket = null;
// let socket = null;
let ChatSocket=null;
export function initNotif() {
    return (dispatch, getState) => {
        NotifSocket = socketIOClient(`${ API_ENDPOINT_Socket}/utils`, {
            query: {
                id: JSON.parse(localStorage.getItem("id")) && JSON.parse(localStorage.getItem("id"))
            }
        }
        );
        NotifSocket.on('connect', () => console.log("sockeeeeeeeeeet con"));
        // console.log('sockeeeeeeeeeet', NotifSocket)
        NotifSocket.on('UpdateUnInformedNotification', data => {
            console.log("sockeeeeeeeeeet socketData:", data)
            dispatch({ type: UPDATE_NOTIFICATION_COUNT, payload: data });
        })
       

    }
}

export function init() {
    return (dispatch, getState) => {
        guest = socketIOClient(`${ API_ENDPOINT_Socket}/chat`, {
            query: {
                id:localStorage.getItem("id")? JSON.parse(localStorage.getItem("id")) && JSON.parse(localStorage.getItem("id")):'',
                // type: "GUEST",
            },
            // 'force new connection': true
        });
        guest.on('connect', () => console.log("CHAATTEST con"));
        // console.log('CHAATTEST geust', guest)
        guest.on('NewMessage', (data) => {
            // console.log("CHAATTEST guest Data:", data.message)
            dispatch({ type: FETCH_NEW_MESSAGE, payload: data.message});
        })
        guest.on('Typing', (data) => {
            console.log("CHAATTEST Typing", data.user)
            dispatch({ type: FETCH_USER_TYPING, payload: true });
        })
        guest.on('StopTyping', (data) => {
            console.log("CHAATTEST StopTyping", data)
            dispatch({ type: FETCH_USER_TYPING, payload: false });
        })
        guest.on('UnseenCount', data => {
            console.log("sockeeeeeeeeeet message socketData:", data)
            dispatch({ type: UPDATE_MESSAGE_COUNT, payload: data });
        })
        // dispatch({ type: FETCH_TOKEN, payload: token });
    }
}
// export function initChat() {
//     return (dispatch, getState) => {
//         ChatSocket = socketIOClient(`${API_ENDPOINT}/utils`, {
//             query: {
//                 id: JSON.parse(localStorage.getItem("id")) && JSON.parse(localStorage.getItem("id"))
//             }
//         }
//         );
//         ChatSocket.on('connect', () => console.log("Chat sockeeeeeeeeeet con"));
//         ChatSocket.on('UpdateUnInformedNotification', data => {
//             console.log("sockeeeeeeeeeet socketData:", data)
//             dispatch({ type: UPDATE_NOTIFICATION_COUNT, payload: data });
//         })
       

//     }
// }
export function typing( id) {
    return (dispatch, getState) => {
        guest.emit('Typing', { user: id} )
    }
}
export function stopTyping( id) {
    return (dispatch, getState) => {
        guest.emit('StopTyping', { user: id} )
    }
}

export function emit(data, id) {
    // console.log('CHAATTEST socket INIT MESSAGE', data, id)
    return (dispatch, getState) => {
        guest.emit('NewMessage', {message:data, to:id})
    }
}
export function clearMessage() {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_NEW_MESSAGE });
    }
}
export function clearMsgCount(){
    console.log("Clear count calllled")
    return (dispatch, getState) => {
        dispatch({ type: CLEAR_MSG_COUNT });
    }
}

export function clearNotificationCount(){
    console.log("Clear count calllled")
    return (dispatch, getState) => {
        dispatch({ type: CLEAR_NOTIFICATION_COUNT });
    }
}